export default __webpack_public_path__ + "static/media/ganeshji.e9118875aec917c3fbba7f387ab86efa.webp";